import React from 'react';
import { useAccountView } from '../../hooks/useAccountView';
import UserInformation from '../items/Account/UserInformation';
import AgencyInformation from '../items/Account/AgencyInformation';
import AccountSkeleton from '../items/Account/AccountSkeleton';
import EmailVerificationBanner from '../common/EmailVerificationBanner';
import TrialStatusCard from '../common/TrialStatusCard';
import styles from '../../styles/Account.module.css';

interface AccountProps {
    userDetails: any;
    onLogout: () => void;
    onUserDetailsUpdate: (updatedUser: any) => void;
}

const Account: React.FC<AccountProps> = ({ userDetails, onLogout, onUserDetailsUpdate }) => {
    const { currentView } = useAccountView({ userDetails, onLogout });

    const handleProfileUpdate = (updatedUser: any) => {
        onUserDetailsUpdate(updatedUser);
    };

    if (!userDetails) {
        return <AccountSkeleton />;
    }

    return (
        <div className={styles.accountContent}>
            <div className={styles.accountInner}>
                {/* Email Verification Banner - Only show if email is not verified */}
                {userDetails?.emailVerified === false && (
                    <EmailVerificationBanner userEmail={userDetails?.email} />
                )}

                {currentView === 'user' && (
                    <UserInformation
                        userDetails={userDetails}
                        handleProfileChange={handleProfileUpdate}
                    />
                )}
                {currentView === 'agency' && (
                    <AgencyInformation userDetails={userDetails} />
                )}

                {/* Trial / Subscription Status Card */}
                {userDetails?.agency && (
                    <TrialStatusCard
                        isOnTrial={userDetails.agency.isOnTrial || false}
                        trialDaysRemaining={userDetails.agency.trialDaysRemaining || 0}
                        trialEndDate={userDetails.agency.trialEndDate}
                        paymentStatus={userDetails.agency.paymentStatus}
                        paidUntil={userDetails.agency.paidUntil}
                    />
                )}
            </div>
        </div>
    );
};

export default Account;
